module.exports = __webpack_public_path__ + "img/app-store-badge@2x.1b8c575d.png";